import React, { useContext } from 'react';

export const AppContext = React.createContext({});
export const AppProvider = AppContext.Provider;
export const AppConsumer = AppContext.Consumer;

AppContext.displayName = 'AppContext';

export const useApp = () => useContext(AppContext);
